import React, { FC, ReactNode } from 'react';

interface IComponentProps {
  icon: ReactNode;
  background: string;
}

export const IconBackground: FC<IComponentProps> = ({ icon, background }) => {
  return (
    <div className="icon-background" style={{ background }}>
      {icon}
    </div>
  );
};
